/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetExamStatisticsByExamPeriod = require('../services/GetExamStatisticsByExamPeriod');
var GetExamPeriodById = require('../services/GetExamPeriodById');

var NonDepInternalExamStatisticsView = require('../views/NonDepInternalExamStatisticsView');

module.exports = function(examYearId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetExamStatisticsByExamPeriod(examYearId), GetExamPeriodById(examYearId)).done(function(examStat, examPeriod) {
    NavUtils.navigate('nondep/dashboard/exams/' + examYearId + '/statistics');
    Scaffold.content.show(
      new NonDepInternalExamStatisticsView({
        model: new Backbone.Model({ examStat: examStat, examYear: examPeriod.yearPeriod, examYearId: examYearId })
      })
    );
    NProgress.done();
  });
};
